<section class="content">
    <div class="content-padding">
        <h4 class="section-header">{{ '@articleRequestErrorHeader' | translate }}</h4>
        <div>{{ '@protocolNotSupported' | translate }}
            <div class="step-text">
                <p >{{ '@articleRequestErrorMessage' | translate }}</p>
            </div>
        </div>
        <p></p>
        <hr />
    </div>
</section>